import React, { useCallback } from 'react'
import { useRequest } from '@/hooks/useRequest'
import { useSelector, useDispatch } from 'react-redux'
import { RadioGroup } from '@/components/RadioGroup'
import { SelectForm } from '@/components/SelectForm'
import { ISpecData } from '@/types/fepoPages'
import { setSpecialities, setSpecId, changeOrgType } from '../../actions'

export const Specialities = () => {
  const dispatch = useDispatch()
  const { orgType='vuz' } = useSelector((state: any) => state)

  const [data, isLoading, error] = useRequest<ISpecData>({
    url: '/fgos_pim_struct/getSpecialties',
    body: {},
    onSuccess: (res) => dispatch(setSpecialities(res))
  }, [])

  const specsData = data?.[orgType].map(s => ({
    id: s.id,
    value: `${s.code} - ${s.name}`
  }))

  return (
    <>
      <RadioGroup
        header='Уровень образования'
        fields={[
          { name: 'высшее образование', value: 'vuz' },
          { name: 'среднее профессиональное образование', value: 'ssuz' }
        ]}
        checked='vuz'
        onChange={useCallback((orgType) => dispatch(changeOrgType(orgType)), [])}
      />

      <SelectForm
        data={specsData}
        header={<label>Код и наименование направления подготовки / специальности / профессии:</label>}
        isLoading={isLoading}
        onChange={useCallback((specId) => dispatch(setSpecId(specId)), [])}
        disabled={!!error}
        search
      />
    </>
  )
}
